module.exports = __webpack_public_path__ + "static/img/cloud.069b6d1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cloud.gif
// module id = tuAV
// module chunks = 1